import { IVisaPrepForm } from '../../../../../../types';

type Fields = Pick<
  IVisaPrepForm,
  | 'hasBeenToUk'
  | 'hasNINumber'
  | 'niNumber'
  | 'hasReceivedMedicalTreatment'
  | 'hasVoluntarilyDeparted'
  | 'hasExclusionOrder'
  | 'exclusionOrders'
>;

type Params = Fields & {
  hasTravelledToUk: boolean;
};

export function getPageStatus({
  hasTravelledToUk,
  hasBeenToUk,
  hasNINumber,
  niNumber,
  hasReceivedMedicalTreatment,
  hasVoluntarilyDeparted,
  hasExclusionOrder,
  exclusionOrders
}: Params): { complete: boolean } {
  let complete = false;
  if (hasBeenToUk !== undefined) {
    if (hasTravelledToUk === false && hasBeenToUk === false) {
      complete = true;
    } else {
      let formComplete = true;

      if (
        hasNINumber === undefined ||
        (hasNINumber === true && niNumber === '') ||
        hasReceivedMedicalTreatment === undefined ||
        hasVoluntarilyDeparted === undefined ||
        hasExclusionOrder === undefined
      ) {
        formComplete = false;
      }

      if (formComplete && hasExclusionOrder === true) {
        if (!exclusionOrders || exclusionOrders.length === 0) {
          formComplete = false;
        } else {
          formComplete = !exclusionOrders.some(order => {
            return order.reason === '' || order.reference === '' || order.exclusionDate === '';
          });
        }
      }

      complete = formComplete;
    }
  }

  return { complete };
}
